import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Widget } from './Widget';
import { AreaChartSomethingWrong } from './AreaChartSomethingWrong';

export type AreaWidgetErrorBoundaryProps = {
  title: string;
  children: React.ReactNode;
  xAxisLabels?: string[];
};

export const AreaWidgetErrorBoundary = ({
  title,
  children,
  xAxisLabels,
}: AreaWidgetErrorBoundaryProps) => {
  return (
    <ErrorBoundary
      fallbackRender={() => (
        <Widget title={title}>
          <AreaChartSomethingWrong xAxisLabels={xAxisLabels} />
        </Widget>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
